exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#SignatureComponent .bordered{border:2px dashed rgba(0,0,0,.38)}#SignatureComponent .bordered-red{border-color:red}", ""]);

// exports
